import moment from 'moment';
import {
  format,
  formatISO,
  formatISO9075,
  formatRFC7231,
  parse,
  parseISO,
  addSeconds,
  intervalToDuration,
  formatDuration,
  isValid,
} from 'date-fns';
import i18n from '@/i18n';

const valueFormatters = {
  Mulligans: (value) => {
    return value === -1 || value === '-1' ? 'Unlimited' : value;
  },
  // 'Pin Position': (value) => {
  //   return value === 0 ? 'Random' : `Position ${value}`;
  // },
  // Add other formatters as needed
};

export const utility_formatSettingValue = (header, value) => {
  if (valueFormatters[header]) {
    return valueFormatters[header](value);
  }
  return value;
};

export const utility_hasClipboard = () => {
  return !!navigator.clipboard;
};

export const utility_onResize = () => {
  if (window.innerWidth < 601) {
    this.isMobile = true;
  } else {
    this.isMobile = false;
  }
};

export const utility_lastSix = (s) => {
  if (!s || s === undefined) return '';
  const d = s?.toString();
  return d.substr(d.length - 6);
};

export const utility_firstEight = (s) => {
  if (!s || s === undefined) return '';
  const d = s?.toString();
  return d.substr(0, 8);
};

export const utility_yesNo = (v) => {
  if (v === undefined) return;
  if (v) {
    return `Yes`;
  }
  return `No`;
};

export const utility_capitalize = (word) => {
  if (word === undefined) return;
  if (word && typeof word === 'string') {
    return word?.charAt(0)?.toUpperCase() + word?.slice(1);
  }
};

export const utility_capitalizeWords = (words) => {
  if (words && typeof words === 'string') {
    const splitWords = words?.split(' ');
    return (
      splitWords
        .map((word) => {
          return word[0]?.toUpperCase() + word?.substring(1);
        })
        ?.join(' ') ?? ''
    );
  }
};

export const utility_percentage = (v) => {
  if (v || v === 0) return `${(v * 100).toFixed(1)}%`;
  return '-';
};

export const utility_valueCheck = (v) => {
  if (v === undefined || v === null || v?.toLowerCase() === 'undisclosed') return 'N/A';
  return v;
};

export const utility_formatCurrency = (value) => {
  if (typeof value !== 'number' || isNaN(value)) {
    return '-';
  }
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
  });
  return formatter.format(value);
};

export const utility_centsToDollars = (num) => {
  if (!num) {
    num = 0;
  }
  const dollars = parseInt(num) / 100;
  return dollars;
};

export const utility_gameModeFormat = (mode) => {
  if (mode) {
    switch (mode) {
      case 'ClosesttothePin':
      case 'ClosestToPin':
      case 'closest_to_pin':
        return i18n.t('gameMode.ktp');
      case 'LongDrive':
      case 'LongestDrive':
      case 'longest_drive':
        return i18n.t('gameMode.longDrive');
      case 'LongDriveWorldSeries':
        return i18n.t('gameMode.longDriveWS');
      case 'StrokePlay':
      case 'stroke_play':
        return i18n.t('gameMode.strokePlay');
      case 'Blackout':
      case 'Solaro':
      case 'Blackout-Solaro':
      case 'Solaro-Blackout':
      case 'minigame_blackout':
      case 'minigame_solaro':
        return i18n.t('gameMode.solaroBlackout');
      case 'minigame_blackoutrange':
      case 'minigame_rangeblackout':
        return i18n.t('gameMode.solaroBlackoutRange');
      case 'Darts':
      case 'Henyett-Darts':
      case 'minigame_darts':
        return i18n.t('gameMode.darts');
      case 'minigame_horse':
      case 'Horse':
        return i18n.t('gameMode.horse');
      case 'minigame_tennis':
      case 'Tennis':
        return i18n.t('gameMode.tennis');
      case 'minigame_301':
      case '301':
        return i18n.t('gameMode.301');
      case 'minigame_highscore':
      case 'HighScore':
        return i18n.t('gameMode.highScore');
      case 'minigame_billiards':
      case 'Billiards':
        return i18n.t('gameMode.billiards');
      case 'minigame_demolition_driving_range':
        return i18n.t('gameMode.e6ddr');
      case 'minigame_ddr':
        return i18n.t('gameMode.ddr');
      case 'minigame_shotforshot':
        return i18n.t('gameMode.shotForShot');
      case 'minigame_smashhit':
        return i18n.t('gameMode.smashHit');
      case 'minigame_longdriverange':
        return i18n.t('gameMode.longDriveRange');
      case 'minigame_ldworldseries':
        return i18n.t('gameMode.longDriveWS');
      case 'minigame_lasvegas':
        return i18n.t('gameMode.lasVegas');
      case 'minigame_icetrolls':
        return i18n.t('gameMode.iceTrolls');
      case 'minigame_battlestations':
        return i18n.t('gameMode.battleStations');
      case 'minigame_carnival':
        return i18n.t('gameMode.carnival');
      case 'chip_n_putt':
        return i18n.t('gameMode.chipNPutt');
      case 'practice_driving_range':
      case 'driving_range':
        return i18n.t('gameMode.drivingRange');
      case 'practice_chip_n_putt':
        return i18n.t('gameMode.chipPutt');
      case 'match_play':
        return i18n.t('gameMode.match');
      case 'scramble':
      case 'Scramble':
        return i18n.t('gameMode.scramble');
      case 'best_ball':
      case 'BestBall':
        return i18n.t('gameMode.bestBall');
      case 'stableford':
        return i18n.t('gameMode.stableford');
      case 'stableford_modified':
        return i18n.t('gameMode.stablefordMod');
      case 'wsog':
        return i18n.t('gameMode.wsog');
      case 'performance_team_stroke':
        return i18n.t('gameMode.perfTeam');
      case 'inhouse_tool.ai_testing':
        return i18n.t('gameMode.ai');
      default:
        return i18n.t('gameMode.default');
    }
  }
  return i18n.t('gameMode.default');
};

export const utility_discountPercentage = (product, regPrice, discount) => {
  if (product && product?.promotion && !discount?.price) {
    return i18n.t('store.general.special');
  }

  if (regPrice?.price && discount?.price) {
    const { price: discountPrice } = discount;
    const { price: regularPrice } = regPrice;
    const percentage = (((regularPrice - discountPrice) / regularPrice) * 100).toFixed(0);
    return `${percentage}% ${i18n.t('store.general.off')}`;
  }
  return '-';
};

export const utility_formatDateAndTime = (date) => {
  if (date === undefined || date === null) return;
  const formattedDate = date.replace('Etc/GMT', '');
  return `${moment(formattedDate).format('L LT')}`; //* 01/22/2019 4:00 PM
};

export const utility_formatDateAndTimeUTC = (date) => {
  if (date === undefined || date === null) return;
  const formattedDate = date.replace('Etc/GMT', '');
  return `${moment.utc(formattedDate).format('L LT')}`; // 01/22/2019 4:00 PM
};

export const utility_formatDateAndTimeDB = (date) => {
  if (date === undefined || date === null) return;
  const dateFormat = formatISO9075(parseISO(date), { representation: 'date' });
  const dbDateFormat = formatRFC7231(parseISO(date));
  const splitGMTTime = dbDateFormat.split(/(\d+:\d+:\d+\sGMT)/)[1];
  return `${dateFormat} ${splitGMTTime}`; // 2021-08-24 22:45:31 GMT
};

export const utility_formatDateAndTimeOpen = (date) => {
  if (date === undefined || date === null) return 'Open';
  return `${moment(date).format('L LT')}`; // 01/22/2019 4:00 PM
};

export const utility_formatDateMonthAndYear = (date) => {
  if (date === undefined || date === null) return 'Open';
  return `${moment(date).format('L')}`; // 01/18/2022
};

export const utility_formatDateMY = (date) => {
  if (date === undefined || date === null) return;
  // return `${format(parseISO(date), 'P')}`; // 01/18/2022
  return `${format(parseISO(date), 'PP')}`; // Jan 22, 2022
};

export const utility_formatTimeToMonthAndYear = (time) => {
  if (time === undefined || time === 'N/A') return 'N/A';
  if (time === 'Just Now') return time;
  return moment.utc(String(time), 'YYYY-MM-DDTHH:mm:ssZ').format('MMM D, YYYY'); // Oct 29, 2018
};

export const utility_formatDateFriendly = (date) => {
  if (date === undefined || date === 'N/A') return 'N/A';
  return format(parseISO(date), 'PPP'); // October 29, 2022
  // return moment(date).format('MMM D, YYYY'); // Oct 29, 2018
};

export const utility_formatDateAlt = (date) => {
  if (date === undefined || date === 'N/A') return 'N/A';
  return format(parseISO(date), 'M.dd.yy'); // 1.31.24
};

export const utility_formatDate = (date) => {
  if (date === undefined || date === '') return '-';
  return moment(date).format('MM/DD/YYYY'); // 01/22/2019
};

export const utility_formatDateSlashes = (date) => {
  if (date === undefined || date === '') return '-';
  return `${format(parseISO(date), 'P')}`; // 01/22/2019
};

export const utility_formatTime = (time) => {
  if (time === undefined) return;
  return moment(time).format('LT');
};

export const utility_formatTimeFNS = (time) => {
  if (time === undefined) return;
  return format(parseISO(time), 'hh:mmaaa');
};

export const utility_fromDate = (d) => {
  if (d === '' || d === undefined) return;
  if (moment(d).isBefore()) {
    return `Expired: ${moment(d).format('L LT')}`;
  }
  return `Expires: ${moment(d).format('L LT')}`;
};

export const utility_clubTypeKeyToFriendly = (key) => {
  if (key === undefined) return key;
  return key
    .replace(/([A-Z])/g, ' $1')
    .replace(/^./, (str) => {
      return str.toUpperCase();
    })
    .trim();
};

export const utility_trackingSystemFormat = (ts) => {
  const trackingSystemMap = {
    ernest_sports_es16: 'ES16 Tour',
    trusimapi_fullswing: 'Full Swing Golf',
    fullswing_kit: 'Full Swing Kit',
    full_swing_golf: 'Full Swing Golf (NATIVE INTEGRATION - DO NOT USE)',
    flight_scope: 'FlightScope',
    trusimapi_gts: 'GTS',
    gpro: 'GPro',
    in_development: 'In Development',
    trusimapi_protee: 'ProTee United',
    trusimapi_sportscoach: 'Sports Coach',
    trusimapi_prosim: 'ProSim',
    trusimapi_smartgolf: 'Smart Golf',
    trusimapi_gpro: 'GPRO Xswing-G',
    trusimapi_powerswing: 'Power Swing',
    trusimapi_foresight: 'Foresight',
    trusimapi_holidaygolf: 'Holiday Golf',
    trusimapi_trugolfmini: 'TruGolf Mini TruSimAPI',
    trusimapi_gsagolf: 'GSA Golf',
    trusimapi_premierdivotaction: 'DivotAction Simulator',
    trusimapi_golfin: 'Golf In',
    golfin: 'GolfIn',
    trusimapi_accugolf: 'AccuGolf',
    garmin: 'Garmin Approach R10 Mobile',
    trusimapi_garmin: 'Garmin Approach R10 PC',
    swing_gauge: 'Swing Gauge',
    skytrak: 'SkyTrak',
    skytrak_jp: 'GPRO SkyTrak',
    trusimapi_developer: 'TruSimAPI Developer',
    trusimapi_greenjoy: 'Greenjoy',
    trugolf_trutrack: 'TruTrack',
    trugolf_truflight_2: 'TruFlight 2',
    trugolf_truflight: 'TruFlight',
    trugolf_mini: 'TruGolf Mini',
    trugolf_apogee: 'Apogee',
    trackman_4: 'Trackman 4',
    trackman_3e: 'Trackman 3e',
    trackman_range: 'TrackMan Range',
    tittle_x: 'Tittle X',
    trusimapi_uneekor: 'Uneekor',
    trusimapi_wizgolf: 'WizGolf',
    trusimapi_wrg: 'WindRider Golf',
    trusimapi_kgolf: 'KGolf',
    kgolf: 'KGolf',
    icx: 'ICX',
    phigolf: 'PhiGolf',
  };

  return trackingSystemMap[ts] || ts;
};

export const utility_puttingModeFormat = (mode) => {
  const puttingModeMap = {
    computerDecides: 'Computer Decides',
    playerPuttsOut: 'Player Putts Out',
    autoScoring: 'Auto Scoring',
    playerDecides: 'Player Decides',
    '2FootGimme': '2 Foot Gimme',
    '2FootGimmie': '2 Foot Gimme',
    '5FootGimme': '5 Foot Gimme',
    '5FootGimmie': '5 Foot Gimme',
    '10FootGimme': '10 Foot Gimme',
    '10FootGimmie': '10 Foot Gimme',
    '15FootGimme': '15 Foot Gimme',
    '15FootGimmie': '15 Foot Gimme',
    '20FootGimme': '20 Foot Gimme',
    '20FootGimmie': '20 Foot Gimme',
  };

  return puttingModeMap[mode] || mode.replace(/F/g, ' F').replace(/G/g, ' G');
};

export const utility_terrainTypeFormat = (type) => {
  const terrainMap = {
    kTerrainFairway: 'Fairway',
    kTerrainRough: 'Rough',
    kTerrainDeepGrass: 'Deep Grass',
    kTerrainGreen: 'Green',
    kTerrainBunker: 'Bunker',
    kTerrainWater: 'Water',
    kTerrainPavement: 'Pavement',
    kTerrainFringe: 'Fringe',
    kTerrainGravel: 'Gravel',
    kTerrainEarth: 'Earth',
    kTerrainHardAngular: 'Rock',
    kTerrainWood: 'Wood',
    kTerrainAstroTurf: 'AstroTurf',
    kObjectHard: 'Hard Object',
    kOutOfBounds: 'Out of Bounds',
    kRedStakeHazard: 'Red Stake Hazard',
    kYellowStakeHazard: 'Yellow Stake Hazard',
    kFreeDropHazard: 'Free Drop Hazard',
  };

  return terrainMap[type] || 'Unknown';
};

export const utility_atmosphereFormat = (data) => {
  const atmosphereMap = {
    // clear: 'Clear',
    partly_cloudy: 'Partly Cloudy',
    rain_drizzle: 'Rain Drizzle',
    rain_light: 'Rain Light',
    rain_moderate: 'Rain Moderate',
    rain_downpour: 'Rain Downpour',
    snow_flurries: 'Snow Flurries',
    snow_light: 'Snow Light',
    snow_moderate: 'Snow Moderate',
    snow_blizzard: 'Snow Blizzard',
  };

  return atmosphereMap[data] || data;
};

export const utility_mulliganFormat = (m) => {
  if (m === undefined) return;
  if (m === -1) {
    return `Unlimited`;
  }
  return m;
};

export const utility_cmToFeetAndInches = (cm) => {
  if (cm === null || cm === undefined) return 'DNF';
  if (cm === -1 || cm === 999999 || cm > 3048) return 'DNQ';

  const totalInches = cm * 0.393701;
  const feet = Math.floor(totalInches / 12);
  const inches = Math.round((totalInches % 12) * 10) / 10;

  return feet && inches ? `${feet}′ ${inches}″` : feet ? `${feet}′` : `${inches}″`;
};

// Alternate conversion =======
// convertFeetInches(val) {
//   const scoreFilterValue = this.$options.filters.scoreCheck(val);

//   if (val === -1 || val === 999999 || val === null || val === undefined) {
//     return scoreFilterValue;
//   }
//   const feet = Math.floor(val);
//   const inches = Math.round((val - feet) * 12);

//   //* Metric Conversion
//   if (this.unitType === t('roundDetails.metric')) {
//     //* feet/in to meters = divide val by 3.281
//     return (val / 3.281).toFixed(2);
//   }
//   return `${feet}' ${inches}"`;
// };

// export const utility_convertFeetInches =(val, elevationFlip = false, unitType = 'imperial') {
//   // const scoreFilterValue = this.$options.filters.export const utility_scoreCheck =(val);
//   const scoreFilterValue = this.export const utility_scoreCheck =(val);

//   if (val === -1 || val === 999999 || val === null || val === undefined) {
//     return scoreFilterValue;
//   }
//   const feet = parseInt(val).toFixed(0);
//   const inches = Math.abs((val - feet).toFixed(1)) * 10;
//   if (elevationFlip) {
//     return `${feet * -1}ft ${inches > 0 ? `${inches}in` : ''}`;
//   }

//   //* Metric Conversion
//   if (unitType?.toLowerCase() === 'metric') {
//     //* feet/in to meters = divide val by 3.281
//     return (val / 3.281).toFixed(2);
//   }
//   return `${feet}' ${inches}"`;
// };

// Alternate conversion =======
// roundNumYards(num) {
//   const scoreFilterValue = this.$options.filters.scoreCheck(num);

//   if (num === -1 || num === 999999 || num === null || num === undefined) {
//     return scoreFilterValue;
//   }

//   //* Metric Conversion
//   if (this.unitType === t('roundDetails.metric')) {
//     //* feet to meters = divide val by 3.281
//     return (num / 3.281).toFixed(1);
//   }
//   return (num / 3).toFixed(1);
// };

// export const utility_roundNumYards =(num, unitType = 'imperial') {
//   // const scoreFilterValue = this.$options.filters.export const utility_scoreCheck =(num);
//   const scoreFilterValue = this.export const utility_scoreCheck =(num);

//   if (num === -1 || num === 999999 || num === null || num === undefined) {
//     return scoreFilterValue;
//   }

//   //* Metric Conversion
//   if (unitType?.toLowerCase() === 'metric') {
//     //* feet/in to meters = divide val by 3.281
//     return (num / 3.281).toFixed(2);
//   }
//   return (num / 3).toFixed(2);
// };

export const utility_roundNum = (num) => {
  if (!num) {
    return 0;
  }
  return Math.abs(Math.round(num));
};

export const utility_isObject = (obj) => {
  if (!obj || typeof obj === 'string' || obj === null || typeof obj === 'function') {
    return false;
  }
  return Object.keys(obj).length > 0;
};

export const utility_generalTranslate = (v) => {
  if (v === null || v === undefined) return 'N/A';
  return i18n.t(`general.${v}`);
};

export const utility_copyText = (text) => {
  if (navigator?.clipboard) {
    navigator?.clipboard?.writeText(text).then(
      () => {
        console.log('Copying to clipboard was successful!');
      },
      (err) => {
        console.error('Could not copy text: ', err);
      }
    );
  } else {
    alert('Cannot copy to clipboard');
  }
};

export const utility_getTotalTimeDuration = (timeInSecondsArr = []) => {
  const accSeconds = timeInSecondsArr.reduce((acc, cur) => {
    return acc + cur;
  }, 0);
  const roundedSeconds = Math.round(accSeconds);
  const { years, months, days, hours, minutes, seconds } = intervalToDuration({
    start: 0,
    end: roundedSeconds * 1000,
  });

  const formatted = formatDuration({
    years,
    months,
    days,
    hours,
    minutes,
    seconds,
  });

  return formatted;
};

export const utility_convertHMS = (timeString) => {
  const arr = timeString.split(':');
  const seconds = arr[0] * 3600 + arr[1] * 60 + +arr[2];
  return seconds;
};

export const utility_handicapFormat = (h) => {
  if (h === undefined || h === null) return;
  if (h === '-') return h;
  const hSplit = h.toString().split('-');
  if (hSplit.length > 1) {
    return `+${hSplit[1]}`;
  }
  return hSplit[0];
};

export const utility_toFixedTwoDecimal = (v) => {
  if (!v || v === null || v === undefined) return '';
  if (v.toString().length > 2) {
    return v.toFixed(2);
  }
  return v;
};

// export const utility_toFixedOneDecimal = (v) => {
//   if (v === 0) return 0;
//   if (!v || v === null || v === undefined) return '';
//   if (v.toString().length > 2) {
//     return v.toFixed(1);
//   }
//   return v;
// };

export const utility_toFixedOneDecimal = (v) => {
  if (v === null || v === undefined) return;
  if (v === 'N/A') return v;
  if (v === 0 || v === 0.0 || v === '0' || v === '0.0') return 0;
  const data = v.toString();
  if (data.length > 2) {
    if (data.split('+').length > 1) {
      return Number(data.split('+')?.[1]).toFixed(1);
    }
    return Number(data).toFixed(1);
  }
  return v;
};

export const utility_scoreCheck = (s) => {
  if (s === null || s === undefined) {
    return 'DNF';
  }
  if (s === -1 || s === 999999) {
    return 'DNQ';
  }
  return s;
};

export const utility_formatHHmmss = (time) => {
  if (time === undefined) return '-';
  const arr = time.split(':');
  arr[2] = Math.round(arr[2]).toLocaleString('en-US', {
    minimumIntegerDigits: 2,
  });
  return arr.join(':');
};

export const utility_genderFormat = (val) => {
  switch (val) {
    case 'male':
      return 'M';
    case 'female':
      return 'F';
    default:
      return 'U';
  }
};

export const utility_dexterityFormat = (val) => {
  switch (val) {
    case 'right':
      return 'R';
    case 'left':
      return 'L';
    default:
      return 'U';
  }
};

export const utility_handicapPresence = (val) => {
  if (val || val === 0) return Number(val);
  return '-';
};

export const utility_presence = (val) => {
  const newVal = val?.toString();
  if (newVal && newVal !== 'undisclosed') return val;
  return '-';
};

// utility function to return UTC date and time
export const utility_MformatDateAndTimeUTC = (date) => {
  if (date === undefined || date === null) return;

  try {
    let dateObj;

    if (typeof date === 'string') {
      if (date.includes('/')) {
        dateObj = parse(date, 'MM/dd/yyyy', new Date());
      } else {
        dateObj = parseISO(date);
      }
    } else {
      dateObj = date;
    }

    // Validate the parsed date
    if (!isValid(dateObj)) {
      console.error('Invalid date:', dateObj);
      return;
    }

    // Construct a new Date object as if it were in UTC
    const utcDate = new Date(
      Date.UTC(
        dateObj.getUTCFullYear(),
        dateObj.getUTCMonth(),
        dateObj.getUTCDate(),
        dateObj.getUTCHours(), // Keep original UTC hours
        dateObj.getUTCMinutes(),
        dateObj.getUTCSeconds()
      )
    );

    // Format in UTC
    const formatted = format(utcDate, 'MM/dd/yyyy h:mm aa');

    return formatted;
  } catch (e) {
    console.error('e:', e);
    return 'N/A';
  }
};
